"use strict";
var Observable_1 = require("../../Observable");
var concat_1 = require("../../operator/concat");
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/concat.js
 ** module id = 276
 ** module chunks = 1
 **/